import { httpClient } from '../http/httpClient'

export type GroupByOption =
  | 'DAY'
  | 'SIX_HOURS'
  | 'HOUR'
  | 'THIRTY_MINUTES'
  | 'FIFTEEN_MINUTES'
  | 'FIVE_MINUTES'
  | 'MINUTE'

export interface ChartConsult {
  count: number
  date: string
}

export interface ChartConsultsResponse {
  consults: ChartConsult[]
}

export interface GetChartConsultsParams {
  groupBy: GroupByOption
}

export async function getChartConsults(params: GetChartConsultsParams) {
  const { data } = await httpClient.get<ChartConsultsResponse>(
    '/consults/chart',
    {
      params,
    },
  )

  return data
}
